import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-6 d-none d-md-block" }
const _hoisted_2 = ["src", "alt"]




export default /*@__PURE__*/_defineComponent({
  __name: 'CardImage',
  props: {
    imageSource: {},
    isRight: { type: Boolean },
    isSmallImage: { type: Boolean },
    isLargeImage: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: require(`../../assets/projects/${__props.imageSource}.webp`),
      alt: __props.imageSource,
      class: _normalizeClass(["image", {
        'right-image': __props.isRight,
        'left-image': !__props.isRight,
        'small-image': __props.isSmallImage,
        'large-image': __props.isLargeImage,
      }])
    }, null, 10, _hoisted_2)
  ]))
}
}

})